import React, { lazy } from "react";
import { Routes as AllRoutes, Navigate, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import PrivateRoute from "./PrivateRoute";

const Auth = lazy(() => import("./../pages/Auth"));
const Home = lazy(() => import("./../pages/Home"));
const NotFound = lazy(() => import("./../pages/NotFound"));
const AuthSAML = lazy(() => import("./../pages/AuthSAML"));

const Routes = () => {
	const user = useSelector((state) => state.auth.user);
	let routes = (
		<AllRoutes>
			<Route path="/" element={!user ? <Auth /> : <Navigate to="/home" />} />
			<Route path="/authSAML" element={!user ? <AuthSAML /> : <Navigate to="/home" />} />
			<Route path="/*" element={<PrivateRoute />}>
				<Route path="home" element={<Home />} />
				<Route path="*" element={<NotFound />} />
			</Route>
		</AllRoutes>
	);

	return <main>{routes}</main>;
};

export default Routes;
